import { gql } from "@apollo/client";

export const GET_PROFILE_QUERY = gql`
  query getProfileForHook {
    getMyProfile {
      user {
        id
        uuid
        mobileImage: image(size: 36) {
          twox
          threex
        }
        desktopImage: image(size: 36) {
          twox
          threex
        }
        name
        freeMinutesLeft
        dateOfBirth
        anonymous
        gender
      }
      email
      balance {
        amount
        currency
      }
      isExpert
      phone
      ppAvailable
      tmpPhone
      isEmailVerified
      wbOffer{
        status
        minutesAmount
        price
        productID
      }
    }
  }
`;
